<template>
  <PortalPageShell
    :title="$t('menu.manageRole')"
    :subtitle="$t('portal.roleManager')"
  >
    <ManageRole
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageRole from '../components/role/ManageRole.vue';

export default {
  components: {
    PortalPageShell,
    ManageRole,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
